import React from "react";
import { useExport } from "../../../Hooks/EntityHooks";
import { useGridRequest } from "../../../Components/CGrid/ServerGrid";
import EmptyListError from "../../../Components/EmptyListContainer/EmptyListError";
import EmptyListContainer from "../../../Components/EmptyListContainer/EmptyListContainer";
import { ConnectedAccountPopup } from "../../Origin/AcountPopup";
import { ConnectedAccountProfile } from "../../../Components/Accounts/AccountProfile";
import RelativeTime from "../../../Components/RelativeTime/RelativeTime";
import Moment from "react-moment";
import moment from "moment";
import Button from "../../../Components/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileExcel,
  faSquareParking,
  faSuitcase,
  faPhone,
  faFileSpreadsheet,
  faUserClock,
  faFileContract,
  faTicketSimple,
  faListCheck,
  faFileChartPie,
  faClipboardCheck,
  faUserTie,
  faFileInvoice,
  faCalendarExclamation,
  faGlobe
} from "@fortawesome/pro-light-svg-icons";
import {
  createPdfButton,
  usePdfPermission
} from "../../../Components/Pdf/PdfHelper";
import querystring from "query-string";
import { useExcelQuery } from "../../../Components/Excel/ExcelHelper";
import classnames from "classnames";
import { FormattedMessage, useIntl } from "react-intl";
import { VirtualGridRow } from "../../../Components/VirtualGrid/VirtualGrid";
import VirtualServerAwareGrid from "../../../Components/VirtualGrid/VirtualServerAwareGrid";
import { DefaultColumnsWidth } from "../../../Components/CGrid/GridDefinitions";
import {
  faArrowAltCircleUp,
  faCalendar,
  faEquals,
  faFile,
  faFileExport,
  faUser,
  faWindow
} from "@fortawesome/pro-solid-svg-icons";
import { moduleTypes } from "../../../Helpers/ModulesHelper";
const OrganizationRow = React.memo(({ value, ...rest }) => {
  const v = useExport(value);
  return <VirtualGridRow value={v} {...rest} />;
});

const IconText = ({ routeModule, textOveride }) => {
  const { text, icon } = routeModule;
  return (
    <div className="d-flex">
      {icon && (
        <div className="ar-header-link-icon-grid mr-2">
          <FontAwesomeIcon icon={icon} />
        </div>
      )}
      <span className="text-truncate">{textOveride ? textOveride : text}</span>
    </div>
  );
};

// const ExportHistoryViewTypeEnum = {
//   1: "Client",
//   2: "Project",
//   3: "ClientContract",
//   4: "TimeCharge",
//   5: "Report",
//   6: "Call",
//   7: "Contact",
//   8: "Ticket",
//   9: "ProjectTask",
//   10: "Deal",
//   11: "Classification",
//   12: "Billing",
// 	13: "Subscriptions"
// };

export const ExportHistoryViewTypeEnumDictForTranslation = {
  1: "ACCOUNTS",
  2: "PROJECTS",
  3: "CONTRACTS",
  4: "TIMES",
  5: "CLASSIFICATION_REPORT",
  6: "CALLS",
  7: "CONTACTS",
  8: "CASES",
  9: "TASKS",
  10: "DEALS",
  11: "CLASSIFICATION",
  12: "BILLING",
  13: "SUBSCRIPTIONS",
  14: "SPACES",
  15: "EMAIL",
  16: "PRODUCTIVITY",
  17: "TRAVEL_TIMES",
  18: "EMAIL_CONVERSATION"
};

export const ExportModulesViewTypeEnum = {
  1: moduleTypes.clients,
  2: moduleTypes.projects,
  3: moduleTypes.contracts,
  4: moduleTypes.interventions,
  5: moduleTypes.reportsClassification,
  6: moduleTypes.calls,
  7: moduleTypes.contacts,
  8: moduleTypes.tickets,
  9: moduleTypes.projects,
  10: moduleTypes.deals,
  11: moduleTypes.classification,
  12: moduleTypes.billing,
  13: moduleTypes.subscriptions,
  14: moduleTypes.spaceList,
  15: moduleTypes.emailConversations,
  16: moduleTypes.classification,
  17: moduleTypes.classification,
  18: moduleTypes.emailConversations
};

export const ExportHistoryViewTypeEnumDict = {
  1: (
    <IconText
      routeModule={{
        icon: faSuitcase,
        text: <FormattedMessage id="ACCOUNTS" />
      }}
    />
  ),
  2: (
    <IconText
      routeModule={{
        icon: faSquareParking,
        text: <FormattedMessage id="PROJECTS" />
      }}
    />
  ),
  3: (
    <IconText
      routeModule={{
        icon: faFileContract,
        text: <FormattedMessage id="CONTRACTS" />
      }}
    />
  ),
  4: (
    <IconText
      routeModule={{ icon: faUserClock, text: <FormattedMessage id="TIMES" /> }}
    />
  ),
  5: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="TIMES" />
      }}
      textOveride={<FormattedMessage id="CLASSIFICATION_REPORT" />}
    />
  ),
  6: (
    <IconText
      routeModule={{ icon: faPhone, text: <FormattedMessage id="CALLS" /> }}
    />
  ),
  7: (
    <IconText
      routeModule={{
        icon: faUserTie,
        text: <FormattedMessage id="CONTACTS" />
      }}
    />
  ),
  8: (
    <IconText
      routeModule={{
        icon: faTicketSimple,
        text: <FormattedMessage id="CASES" />
      }}
    />
  ),
  9: (
    <IconText
      routeModule={{
        icon: faListCheck,
        text: <FormattedMessage id="TASKS" />
      }}
    />
  ),
  10: (
    <IconText
      routeModule={{
        icon: faFileChartPie,
        text: <FormattedMessage id="DEALS" />
      }}
    />
  ),
  11: (
    <IconText
      routeModule={{
        icon: faClipboardCheck,
        text: <FormattedMessage id="CLASSIFICATION" />
      }}
    />
  ),
  12: (
    <IconText
      routeModule={{
        icon: faFileInvoice,
        text: <FormattedMessage id="BILLING" />
      }}
    />
  ),
  13: (
    <IconText
      routeModule={{
        icon: faCalendarExclamation,
        text: <FormattedMessage id="SUBSCRIPTIONS" />
      }}
    />
  ),
  14: (
    <IconText
      routeModule={{
        icon: faGlobe,
        text: <FormattedMessage id="SPACE" />
      }}
    />
  ),
  15: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="EMAIL" />
      }}
      textOveride={<FormattedMessage id="EMAIL" />}
    />
  ),
  16: (
    <IconText
      routeModule={{
        icon: faClipboardCheck,
        text: <FormattedMessage id="PRODUCTIVITY" />
      }}
    />
  ),
  17: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="TIMES" />
      }}
      textOveride={<FormattedMessage id="TRAVEL_TIMES" />}
    />
  ),
  18: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="EMAIL_CONVERSATION" />
      }}
      textOveride={<FormattedMessage id="EMAIL_CONVERSATION" />}
    />
  )
};

export const ExportHistoryTypeEnumDict = {
  1: (
    <IconText
      routeModule={{
        icon: faSuitcase,
        text: <FormattedMessage id="ACCOUNTS" />
      }}
    />
  ),
  2: (
    <IconText
      routeModule={{
        icon: faSquareParking,
        text: <FormattedMessage id="PROJECTS" />
      }}
    />
  ),
  3: (
    <IconText
      routeModule={{
        icon: faFileContract,
        text: <FormattedMessage id="CONTRACTS" />
      }}
    />
  ),
  4: (
    <IconText
      routeModule={{ icon: faUserClock, text: <FormattedMessage id="TIMES" /> }}
    />
  ),
  5: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="TIMES" />
      }}
      textOveride={<FormattedMessage id="CLASSIFICATION_REPORT" />}
    />
  ),
  6: (
    <IconText
      routeModule={{ icon: faPhone, text: <FormattedMessage id="CALLS" /> }}
    />
  ),
  7: (
    <IconText
      routeModule={{
        icon: faUserTie,
        text: <FormattedMessage id="CONTACTS" />
      }}
    />
  ),
  8: (
    <IconText
      routeModule={{
        icon: faTicketSimple,
        text: <FormattedMessage id="CASES" />
      }}
    />
  ),
  9: (
    <IconText
      routeModule={{
        icon: faListCheck,
        text: <FormattedMessage id="TASKS" />
      }}
    />
  ),
  10: (
    <IconText
      routeModule={{
        icon: faFileChartPie,
        text: <FormattedMessage id="DEALS" />
      }}
    />
  ),
  11: (
    <IconText
      routeModule={{
        icon: faClipboardCheck,
        text: <FormattedMessage id="CLASSIFICATION" />
      }}
    />
  ),
  12: (
    <IconText
      routeModule={{
        icon: faFileInvoice,
        text: <FormattedMessage id="BILLING" />
      }}
    />
  ),
  13: (
    <IconText
      routeModule={{
        icon: faCalendarExclamation,
        text: <FormattedMessage id="SUBSCRIPTIONS" />
      }}
    />
  ),
  14: (
    <IconText
      routeModule={{
        icon: faGlobe,
        text: <FormattedMessage id="SPACE" />
      }}
    />
  ),
  15: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="EMAIL" />
      }}
      textOveride={<FormattedMessage id="EMAIL" />}
    />
  ),
  16: (
    <IconText
      routeModule={{
        icon: faCalendarExclamation,
        text: <FormattedMessage id="PRODUCTIVITY" />
      }}
      textOveride={<FormattedMessage id="PRODUCTIVITY_REPORT" />}
    />
  ),
  17: (
    <IconText
      routeModule={{
        icon: faFileSpreadsheet,
        text: <FormattedMessage id="TIMES" />
      }}
      textOveride={<FormattedMessage id="TRAVEL_TIMES" />}
    />
  ),
  18: (
    <IconText
      routeModule={{
        icon: faCalendarExclamation,
        text: <FormattedMessage id="EMAIL_CONVERSATION" />
      }}
      textOveride={<FormattedMessage id="EMAIL_CONVERSATION" />}
    />
  )
};

// const ExportHistoryTypeEnumDict = {
//   1: <IconText routeModule={clientRoute} />,
//   2: <IconText routeModule={projectRoute} />,
//   3: <IconText routeModule={contractRoute} />,
//   4: <IconText routeModule={interventionRoute} />,
//   5: <IconText routeModule={reportsRoute} textOveride="Report Tempos" />,
//   6: <IconText routeModule={callRoute} />,
//   7: <IconText routeModule={contactRoute} />,
//   8: <IconText routeModule={ticketRoute} />,
//   9: <IconText routeModule={taskRoute} />,
//   10: <IconText routeModule={dealRoute} />,
//   11: <IconText routeModule={classificationRoute} />,
//   12: <IconText routeModule={billingRoute} />
// };

const PdfButton = createPdfButton({
  // generateUrl: ({ id }) => Data.ExportFile,
  download: true,
  // url: Data.ExportFile,
  //   buildUrl: ({ id, token }) => `interventions/Export/BuildPdf/${id}/${token}`,
  chooseDate: false
  // moduleType: moduleTypes.interventions
});

const ExcelButton = ({
  directUrl,
  className,
  link,
  fileId,
  ExportType,
  moduleTypeExtra
}) => {
  const post = useExcelQuery(directUrl, ExportType, fileId);
  const disabled = !usePdfPermission(ExportType || moduleTypeExtra);
  return (
    <Button
      disabled={disabled}
      style={{ visibility: "visible" }}
      className={classnames(
        {
          "ssi-button-grid sm": !link,
          "ssi-button-link text-left": link
        },
        className
      )}
      vType={link ? null : "primary-ghost"}
      onClick={post}
    >
      <FontAwesomeIcon icon={faFileExcel} />
    </Button>
  );
};

const ExportButton = ({
  url = "",
  ExportType,
  PathFile,
  id,
  EndDateInterval,
  BeginDateInterval
}) => {
  // console.log(url, ExportType)
  const resolvedUrl = /\?[\S]+=/g.test(url)
    ? "&fromSettings=true"
    : "?fromSettings=true";
  const queryObj = querystring.parse(url.split("?")[1]);
  const intl = useIntl();
  if (
    queryObj.isexcel ||
    queryObj.excel ||
    new RegExp("^.*excel?.*$").test(url.toLowerCase())
  ) {
    if (PathFile) {
      return (
        <ExcelButton
          fileId={id}
          fromSettings={true}
          directUrl={PathFile}
          ExportType={
            intl.formatMessage({
              id: ExportHistoryViewTypeEnumDictForTranslation[ExportType] || ""
            }) +
            "_" +
            moment(BeginDateInterval).format("DD-MM-YYYY") +
            "_" +
            moment(EndDateInterval).format("DD-MM-YYYY")
          }
        />
      );
    } else
      return (
        <ExcelButton
          fileId={id}
          fromSettings={true}
          directUrl={url + resolvedUrl}
          moduleTypeExtra={ExportModulesViewTypeEnum[ExportType]}
        />
      );
  } else {
    if (PathFile) {
      return (
        <PdfButton
          id={id}
          moduleTypeExtra={ExportModulesViewTypeEnum[ExportType]}
          fromSettings={true}
          buttonStyle={{ visibility: "visible" }}
          directUrl={PathFile}
        />
      );
    } else
      return (
        <PdfButton
          id={id}
          moduleTypeExtra={ExportModulesViewTypeEnum[ExportType]}
          payload={queryObj["$payload"]}
          fromSettings={true}
          buttonStyle={{ visibility: "visible" }}
          directUrl={url + resolvedUrl}
        />
      );
  }
};

const columns = [
  // {
  //   sortable: false,
  //   field: "Id",
  //   title: "Id",
  //   width: DefaultColumnsWidth.id,
  // },

  {
    headerIcon: faCalendar,
    sortable: false,
    width: DefaultColumnsWidth.ReceivedDate,
    field: "Date",
    title: <FormattedMessage id={"DATE"} />,
    Cell: ({ Data }) => <RelativeTime date={Data.Date} />
  },
  {
    headerIcon: faUser,
    sortable: false,
    width: DefaultColumnsWidth.CreatorName,
    field: "Account",
    title: <FormattedMessage id={"USER"} />,
    Cell: ({ Data }) => {
      return (
        <ConnectedAccountPopup account={Data.Account}>
          <ConnectedAccountProfile account={Data.Account} />
        </ConnectedAccountPopup>
      );
    }
  },
  {
    headerIcon: faEquals,
    sortable: false,
    width: DefaultColumnsWidth.id,
    field: "ExportQuantity",
    title: <FormattedMessage id={"QUANTITY"} />,
    Cell: ({ Data }) => (
      <div className="d-flex justify-content-end align-items-center">
        {!Data.Success && Data.FullRequest ? "―" : Data.ExportQuantity}
      </div>
    )
  },
  {
    headerIcon: faFileExport,
    sortable: false,
    width: DefaultColumnsWidth.Title,
    field: "ExportType",
    title: <FormattedMessage id={"EXPORT_TYPE"} />,
    Cell: ({ Data }) => ExportHistoryTypeEnumDict[Data.ExportType] || null
  },
  {
    headerIcon: faWindow,
    sortable: false,
    width: DefaultColumnsWidth.Title,
    field: "ViewType",
    title: <FormattedMessage id={"VIEW"} />,
    Cell: ({ Data }) => ExportHistoryViewTypeEnumDict[Data.ViewType] || null
  },
  // {
  //   sortable: false,
  //   width: DefaultColumnsWidth.Title,
  //   field: "State",
  //   title: <FormattedMessage id={"STATUS"} />,
  // 	Cell: ({ Data }) => StatusDict[Data.Status],
  // },
  {
    headerIcon: faFile,
    sortable: false,
    width: DefaultColumnsWidth.id,
    field: "ExportFile",
    title: <FormattedMessage id={"FILE"} />,
    Cell: ({ Data }) => {
      // if (Data.Status === ExportStatusDict.Success)
      return (
        <ExportButton
          id={Data.Id}
          ExportType={Data.ExportType}
          url={Data.ExportFile}
          BeginDateInterval={Data.BeginDateInterval}
          EndDateInterval={Data.EndDateInterval}
          PathFile={Data.PathFile}
        />
      );
      // else return <span></span>;
    }

    //   <div
    //     className="text-primary cursor-pointer"
    //     onClick={() => {
    //       window.open(`${Data.ExportFile}`);
    //     }}
    //   >
    //     <FontAwesomeIcon size={"lg"} icon={faFile} />
    //   </div>
  },
  {
    headerIcon: faCalendar,
    sortable: false,
    width: DefaultColumnsWidth.SpentTime,
    field: "BeginDateInterval",
    title: <FormattedMessage id={"START_DATE"} />,
    Cell: ({ Data }) =>
      Data.BeginDateInterval ? (
        <Moment
          className="text-black"
          date={Data.BeginDateInterval}
          format="DD/MM/YYYY HH:mm"
        />
      ) : (
        <div>―</div>
      )
  },
  {
    headerIcon: faCalendar,
    sortable: false,
    width: DefaultColumnsWidth.SpentTime,
    field: "EndDateInterval",
    title: <FormattedMessage id={"END_DATE"} />,
    Cell: ({ Data }) =>
      Data.EndDateInterval ? (
        <Moment
          className="text-black"
          date={Data.EndDateInterval}
          format="DD/MM/YYYY HH:mm"
        />
      ) : (
        <div>―</div>
      )
  },
  {
    headerIcon: faArrowAltCircleUp,
    sortable: false,
    width: DefaultColumnsWidth.SpentTime,
    field: "QuantityType",
    title: <FormattedMessage id={"EXPORT_QUANTITY_TYPE"} />,
    Cell: ({ Data }) => {
      if (Data.FullRequest) {
        return <FormattedMessage id={"EXPORT_QUANTITY_TYPE_COMPLETE"} />;
      } else {
        return <FormattedMessage id={"EXPORT_QUANTITY_TYPE_PARCIAL"} />;
      }
    }
  }
];

const ExportsGrid = ({ ...rest }) => {
  const { error, results } = useGridRequest();

  if (error) return <EmptyListError />;

  if (results && results.length === 0)
    return (
      <EmptyListContainer type="interventions">
        <div className="fw-bold fs-24 text-black ">
          <FormattedMessage id={"EMPTY_EXPORT"} />
        </div>
      </EmptyListContainer>
    );
  const columnResize = true;

  return (
    <VirtualServerAwareGrid
      columnResize={columnResize}
      rowComponent={OrganizationRow}
      columns={columns}
      {...rest}
    />
  );
};

export default ExportsGrid;
